import axios from "axios";

export const getLabels = async (
  namespace: string,
  language: string,
  keys: string[]
) => {
  const { data } = await axios.get<{ [key: string]: string }>(
    `${
      process.env.REACT_APP_CONTENT_API
    }/api/v2/labels/${namespace}/${language}?keys=${keys.toString()}`,
    {
      headers: {
        "X-API-Key": process.env.REACT_APP_CONTENT_API_KEY,
        "Access-Control-Allow-Origin": "*",
      },
    }
  );
  // labels with label key as fallback value
  const labels = Object.entries(data)
    .map(([key, value]) => [key, value || key])
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

  return labels;
};
